import {
    UserStatusWithdrawalLimitsToggleCardIconWrapperStyled,
    UserStatusWithdrawalLimitsToggleInfoStyled,
    UserStatusWithdrawalLimitsToggleStyled,
    UserStatusWithdrawalLimitsToggleTitleContainerStyled,
} from './styled/UserStatusWithdrawalLimitsToggleStyled';
import { IWithdrawalLimits, TUserStatusesStates } from '../../UserStatuses.t';
import classNames from 'classnames';
import { USER_STATUSES_STATES } from '../../userStatusesConstants';
import BinIcon from '../../../../components/icon/IconWrapped';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { useCallback, useEffect } from 'react';
import { locationSlice } from '../../../Location/locationReducer';
import { LOCATION_NAMES } from '../../../Location/locationConstants';
import { useDispatch, useSelector } from 'react-redux';
import UserStatusWithdrawalLimitsNumbers from './UserStatusWithdrawalLimitsNumbers';
import { getPayoutParamsAction } from '../../../Withdrawal/withdrawalReducer';
import { getIsLocationPlatformDesktopSelector } from '../../../Location/locationSelectors';

interface IUserStatusWithdrawalLimitsToggleProps {
    statusState: TUserStatusesStates,
    withdrawalLimits?: IWithdrawalLimits
}

function UserStatusWithdrawalLimitsToggle(props: IUserStatusWithdrawalLimitsToggleProps) {
    const { statusState, withdrawalLimits } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);
    const isAllowedOpenWithdrawalLimits = statusState === USER_STATUSES_STATES.PROGRESS;

    const onContainerClickHandler = useCallback(() => {
        if (!isAllowedOpenWithdrawalLimits) {
            return;
        }
        if (isDesktop) {
            dispatch(locationSlice.actions.addLocationAction({ name: LOCATION_NAMES.WITHDRAWAL_LIMITS }));
            return;
        }
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.WITHDRAWAL_LIMITS, method: 'replace' }));
    }, [dispatch, isAllowedOpenWithdrawalLimits, isDesktop]);

    useEffect(() => {
        dispatch(getPayoutParamsAction());
    }, [dispatch]);

    return <UserStatusWithdrawalLimitsToggleStyled
        className={classNames({
            'cursor-pointer': isAllowedOpenWithdrawalLimits,
            disabled: statusState === USER_STATUSES_STATES.COMPLETED,
        })}
        onClick={onContainerClickHandler}
    >
        <UserStatusWithdrawalLimitsToggleCardIconWrapperStyled>
            <BinIcon name={'IcCard'} size={84}/>
        </UserStatusWithdrawalLimitsToggleCardIconWrapperStyled>

        <UserStatusWithdrawalLimitsToggleInfoStyled>
            <UserStatusWithdrawalLimitsToggleTitleContainerStyled>
                <span className={'lh16'}>{getLangPath('user_statuses.withdrawal_limits.withdrawal_without_fee')}</span>
                {isAllowedOpenWithdrawalLimits && <BinIcon name={'IcMoveRight'} size={16} className={'flex-shrink-0'}/>}
            </UserStatusWithdrawalLimitsToggleTitleContainerStyled>

            <UserStatusWithdrawalLimitsNumbers withdrawalLimits={withdrawalLimits}/>
        </UserStatusWithdrawalLimitsToggleInfoStyled>
    </UserStatusWithdrawalLimitsToggleStyled>;
}

export default UserStatusWithdrawalLimitsToggle;
